/* Use Shopify's native preferences UI; never infer or write visitor consent. */
(() => {
  const buttons = document.querySelectorAll('[data-biceek-cookie-settings]');
  if (!buttons.length) return;
  let loading;
  function loadBanner() {
    if (window.privacyBanner?.showPreferences) return Promise.resolve(window.privacyBanner);
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      script.onload = () => window.privacyBanner?.showPreferences ? resolve(window.privacyBanner) : reject(new Error('Banner unavailable'));
      script.onerror = () => reject(new Error('Banner unavailable'));
      document.head.appendChild(script);
    }).catch((error) => { loading = null; throw error; });
    return loading;
  }
  buttons.forEach((button) => button.addEventListener('click', async () => {
    const status = button.closest('footer').querySelector('[data-biceek-privacy-status]');
    status.textContent = '';
    button.disabled = true;
    try {
      const banner = await loadBanner();
      await banner.showPreferences();
    } catch (_) {
      status.textContent = 'Cookie settings could not load. Please try again or contact support@biceek.com.';
    } finally {
      button.disabled = false;
    }
  }));
})();
